import { Pipe, PipeTransform } from '@angular/core';
import { MemberProfileKey } from '@shared/local-storage.key';

@Pipe({
  name: 'amountFormat'
})
export class AmountFormatPipe implements PipeTransform {
    transform(value: string | number, currency?: string): string {
        if (!value) {
            return '';
        }
        const amount = typeof value === 'number' ? String(value) : value;

        let targetCurrency = currency;
        if( !targetCurrency ) {
            targetCurrency = this.getMemberCurrencyCode();
        }

        if( targetCurrency == 'RP' ) {
            const parts = amount.split('.');
            const integerPart = parts[0].replace(/,/g, '.');
            const formattedAmount = `${integerPart},${parts[1] || '00'}`;
            return formattedAmount;
        } else {
            return amount;
        }
    }

    /* `user_data` (template-02's key) is only written by the cross-login / auto-login URL-param
       paths; a normal qply login stores the profile under MemberProfileKey instead, and
       PortalMemberProfileHttpService.updateLocalUserData() can leave a `user_data` with no
       `currency`. Reading `user_data.currency.code` unguarded threw inside every template using
       this pipe, blanking all amounts (seen on the rewards claim dialog). */
    private getMemberCurrencyCode(): string | undefined {
        for (const key of ['user_data', MemberProfileKey]) {
            try {
                const code = JSON.parse(localStorage.getItem(key) || 'null')?.currency?.code;
                if (code) {
                    return code;
                }
            } catch {
                /* malformed entry — try the next key */
            }
        }
        return undefined;
    }
}
